/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { loadDropin } from "utils/DropinUtils";
import { RHPWrapper } from "components/rhp/RHPWrapper";
import {
  getShouldUseModernViewer,
  getSelectedDropinForRHP,
  getShouldEnableOutline,
  getShouldEnableQnA,
  getShouldEnableRHPResizing,
  getRhpSkeletonDropinId
} from "selectors/appSelectors";
import { getShouldRenderCommentsDropin, getShouldRenderPersonalCommentsDropin } from "selectors/overlayDropinSelectors";
import { getFileExtension, rhpVisibility } from "selectors/documentSelectors";
import { getEnabledSkinnyRailVerbs, getTopUIControls, getBottomUIControls } from "selectors/skinnyRailSelectors";
import { dropinNames } from "constants/enums";
import { getConnectorType } from "../../app/AppInitUtility";
import { isCommentingAllowed } from "../../utils/DocPermissionsUtils";
import { getRhpWidth } from "../../selectors/skinnyRailSelectors";

const mapStoreToProps = (stores, ownProps) => {
  const fileExtension = getFileExtension(stores).toLowerCase();
  const connectorAsset = getConnectorType();
  return {
    intl: ownProps.intl,
    shouldUseModernViewer: getShouldUseModernViewer(stores),
    getRHPComponent: () => loadDropin(dropinNames.SKINNY_RAIL),
    selectedDropin: getSelectedDropinForRHP(stores),
    fileExtension,
    connectorAsset,
    showRhp: rhpVisibility(stores),
    enabledVerbs: getEnabledSkinnyRailVerbs(stores),
    topUIControls: getTopUIControls(stores),
    bottomUIControls: getBottomUIControls(stores),
    shouldRenderPersonalCommentsDropin: getShouldRenderPersonalCommentsDropin(stores),
    shouldRenderCommentsDropin: getShouldRenderCommentsDropin(stores),
    rhpSkeletonDropinId: getRhpSkeletonDropinId(stores),
    panelWidth: getRhpWidth(stores),
    enableRHPResizing: getShouldEnableRHPResizing(stores),
    beforeUpdatingActiveDropin: dropinId => {
      if (
        dropinId === "comments" &&
        !isCommentingAllowed() &&
        !getShouldRenderPersonalCommentsDropin(stores) &&
        !getShouldRenderCommentsDropin(stores)
      ) {
        stores.notificationViewStore.addNotification("modernviewer.quickToolsDisabledForProtectedFileToast", {
          shouldRemoveActiveToasts: true,
          timeout: 5000
        });
        throw new Error("Comments are disabled for protected files.");
      }
    }
  };
};

export const RHPWrapperContainer = inject(mapStoreToProps)(RHPWrapper);
